import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      data-testid="mobile-sticky-enquiry-button"
      onClick={() => scrollToId("#contact")}
      className="fixed bottom-4 left-4 right-4 z-40 md:hidden bg-[#A31D4F] text-white py-3.5 px-6 rounded-full shadow-2xl flex items-center justify-between border border-rose-300/30 font-mono text-[11px] uppercase tracking-[0.2em]"
    >
      Professional Enquiry
      <ArrowUpRight size={16} />
    </button>
  );
};

export default MobileStickyCTA;
